var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "top-menu",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "opciones-top"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "perfil"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#fff",
    stroke: "#65a518",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M3.87,14.356H.554A.57.57,0,0,1,0,13.772v-.751A1.417,1.417,0,0,1,1.158,11.6V6.755a4.981,4.981,0,0,1,3.36-4.784c0-.009,0-.018,0-.027V1.538A1.466,1.466,0,0,1,5.893,0,1.466,1.466,0,0,1,7.271,1.538v.406c0,.009,0,.018,0,.027a4.981,4.981,0,0,1,3.36,4.784V11.6a1.416,1.416,0,0,1,1.157,1.421v.751a.57.57,0,0,1-.553.584H7.917a2.105,2.105,0,0,1-2.024,1.716A2.1,2.1,0,0,1,3.87,14.356Z",
    transform: "translate(10.4 8)",
    fill: "#006729"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.98d828f527b6fbcd2acd0b07176c3a1d.svg";
export { ForwardRef as ReactComponent };